import {
  bookingsend,
  propertylist,
  propertysimilarlist,
  rentalsend,
  subamenities,
  visitsend
} from './ApiEndPoint'
import { baseApiCall } from './BaseApiCall'

export const onApiCallPropertyList = (data, params) => {
  return baseApiCall({
    url: propertylist + "/" + "list" + params,
    method: 'post',
    data
  })
}

export const onApiCallPropertyNext = (data, params) => {
  return baseApiCall({
    url: propertylist + "/" + "next" + params,
    method: 'post',
    data
  })
}

export const onApiCallPropertyPrev = (data, params) => {
  return baseApiCall({
    url: propertylist + "/" + "prev" + params,
    method: 'post',
    data
  })
}


export const onApiCallPropertySimilarList = (data, params) => {
  return baseApiCall({
    url: propertysimilarlist + params,
    method: 'post',
    data
  })
}


export const onApiCallPropertyDetails = data => {
  return baseApiCall({
    url: propertylist + '/' + data,
    method: 'get',
  })
}


export const onApiCallSubAmenities = (data, params) => {
  return baseApiCall({
    url: subamenities + '/' + params,
    method: 'post',
    data
  })
}



export const onApiCallBookingSend = (data, params) => {
  return baseApiCall({
    url: bookingsend + params,
    method: 'post',
    data
  })
}

export const onApiCallVisitSend = (data, params) => {
  return baseApiCall({
    url: visitsend + params,
    method: 'post',
    data
  })
}

export const onApiCallRentalSend = (data, params) => {
  return baseApiCall({
    url: rentalsend + params,
    method: 'post',
    data
  })
}


